/* eslint-disable */
import { produce } from "immer";
import {
  LUMP_SUMS_FETCH_FAILURE,
  LUMP_SUMS_FETCH_SUCCESS,
  LUMP_SUMS_FETCH_START,
} from "../actions/types";

const lumpSumsWithdrawal = (
  state = {
    lumpSumsFetching: false,
    lumpSumsData: [],
    lumpSumsError: null,
  },
  action,
) => {
  switch (action.type) {
    case LUMP_SUMS_FETCH_START:
      return produce(state, (draft) => {
        draft.lumpSumsFetching = true;
      });
    case LUMP_SUMS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.lumpSumsFetching = true;
        draft.lumpSumsData = action.data;
        draft.lumpSumsFetching = false;
      });
    case LUMP_SUMS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.lumpSumsFetching = false;
        draft.lumpSumsError = action.error;
      });
    default:
      return state;
  }
};

export default lumpSumsWithdrawal;
